export const divisionePrivateFormFields = [
  {
    name: "nomeCognome",
    label: "Nome e Cognome:",
    type: "text",
  },
  {
    name: "telefono",
    label: "Telefono:",
    type: "text",
  },
  {
    name: "email",
    label: "Email:",
    type: "email",
  },
  {
    name: "messaggio",
    label: "Messaggio:",
    type: "textarea",
  },
  {
    name: "consenso",
    label: "Acconsento al trattamento dei dati",
    type: "checkbox",
    isClickable: true,
  },
]

export const oroPrestigeFormFields = [
    {
      name: "nomeCognome",
      label: "Nome e Cognome:",
      type: "text",
    },
    {
      name: "telefono",
      label: "Telefono:",
      type: "text",
    },
    {
      name: "email",
      label: "Email:",
      type: "email",
    },
    {
      name: "indirizzo",
      label: "Indirizzo:",
      type: "text",
    },
    {
      name: "messaggio",
      label: "Messaggio:",
      type: "textarea",
    },
    {
      name: "consenso",
      label: "Acconsento al trattamento dei miei dati personali come previsto nell'",
      type: "checkbox",
      isClickable: true,
    },
  ];


export function getContactFormFields(provinceOptions = []) {
  return [
    {
      name: "nomeCognome",
      label: "Nome e Cognome:",
      type: "text",
    },
    {
      name: "telefono",
      label: "Telefono:",
      type: "text",
    },
    {
      name: "email",
      label: "Email:",
      type: "email",
    },
    {
      name: "provincia",
      label: "Provincia:",
      type: "select",
      options: [
        {
          value: "",
          label: "Seleziona una provincia",
        },
        ...provinceOptions,
      ],
    },
    {
      name: "InteressatoA",
      label: "Interessato a:",
      type: "select",
      options: [
        { value: "", label: "Seleziona un'opzione" },
        {
          value: "Acquisto di un piano rateale",
          label: "Acquisto di un piano rateale",
        },
        {
          value: "Acquisto unico",
          label: "Acquisto unico",
        },
        {
          value: "Lavorare con noi",
          label: "Lavorare con noi",
        },
      ],
    },
    {
      name: "ComeCiHaConosciuto",
      label: "Come ci hai conosciuto",
      type: "select",
      options: [
        { value: "", label: "Seleziona un'opzione" },
        { value: "Facebook", label: "Facebook" },
        { value: "Instagram", label: "Instagram" },
        { value: "LinkedIn", label: "LinkedIn" },
        { value: "Google Ads", label: "Google Ads" },
        {
          value: "Pubblicità su riviste cartacee",
          label: "Pubblicità su riviste cartacee",
        },
        { value: "Passaparola", label: "Passaparola" },
        { value: "Radio", label: "Radio" },
        { value: "TV", label: "TV" },
        { value: "Sito web", label: "Sito web" },
        { value: "Altro...", label: "Altro..." },
      ],
    },
    {
      name: "altro",
      label: "Altro:",
      type: "text",
      conditional: {
        field: "ComeCiHaConosciuto",
        value: "Altro...",
      },
    },
    {
      name: "messaggio",
      label: "Messaggio:",
      type: "textarea",
    },
    {
      name: "consenso",
      label: "Acconsento al trattamento dei miei dati personali come previsto nell'",
      type: "checkbox",
      isClickable: true,
    },
  ];
}